export enum DualLoginSignupPageStatus {
  Initial,
  RenderingContainer,
  RenderingDualPage,
  NewUserFormTransition,
  RenderingNewUserForm,
  ResetFormTransition,
  RenderingResetForm,
}